module.exports = __webpack_public_path__ + "img/logo.e5e8dcb9.svg";